import i18n from "i18next";
import { initReactI18next } from "react-i18next"; // Correct import path
import Backend from "i18next-http-backend";
import LanguageDetector from "i18next-browser-languagedetector";

// Types pour les formatters personnalisés

// Proper chaining syntax for i18next initialization
i18n
  .use(Backend)
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    lng: "fr",
    fallbackLng: "fr",
    ns: ["common"],
    defaultNS: "common",
    fallbackNS: "common",
    debug: false,
    interpolation: {
      escapeValue: false,
    },
    backend: {
      loadPath: "/assets/locales/{{lng}}/{{ns}}.json",
    },
  });

export default i18n;
